module.exports = __webpack_public_path__ + "img/settings_outlined_32.1d05419e.svg";